module.exports = __webpack_public_path__ + "fonts/VaIcons.87affea5.woff";